// Lógica pura del tab Cerca (Mi Cobro): radios de búsqueda, formateo de
// distancias y zoom del mapa. Sin dependencias de React ni del DOM.

/** Radios de búsqueda disponibles en la UI (decisión de producto CERC-02). */
export const RADIO_CERCA_METROS = {
  CORTA: 250,
  MEDIA: 500,
  ALTA: 1000,
  LARGA: 3000,
} as const;

export type RadioCercaMetros = (typeof RADIO_CERCA_METROS)[keyof typeof RADIO_CERCA_METROS];

/** Opciones de radio en orden ascendente; el slider las consume por índice. */
export const RADIO_CERCA_OPCIONES: readonly RadioCercaMetros[] = [
  RADIO_CERCA_METROS.CORTA,
  RADIO_CERCA_METROS.MEDIA,
  RADIO_CERCA_METROS.ALTA,
  RADIO_CERCA_METROS.LARGA,
];

/** Radio inicial: 1 km (decisión de producto CERC-02). */
export const RADIO_CERCA_DEFECTO: RadioCercaMetros = RADIO_CERCA_METROS.ALTA;

/**
 * Formatea una distancia en metros para copias cortas de lista/mapa:
 * 350 → "350 m", 1500 → "1.5 km", 3000 → "3 km". Valores no finitos o
 * negativos caen a guion (el backend nunca debe emitirlas; defensa UI).
 */
export function formatDistancia(metros: number): string {
  if (!Number.isFinite(metros) || metros < 0) return '—';
  if (metros < 1000) return `${Math.round(metros)} m`;
  const km = metros / 1000;
  const texto = km % 1 === 0 ? String(km) : km.toFixed(1);
  return `${texto} km`;
}

const MAP_ZOOM_MIN = 3;
const MAP_ZOOM_MAX = 17;
const MAP_ZOOM_BASE = 16;
const RADIO_REFERENCIA_METROS = 500;

/**
 * Zoom del mapa proporcional al radio: a mayor radio, menos zoom.
 * 250 → 17, 500 → 16, 1000 → 15, 3000 → 13, con acotación entre 3 y 17.
 */
export function zoomParaRadioCerca(radioMetros: number): number {
  const pasos = Math.round(Math.log2(radioMetros / RADIO_REFERENCIA_METROS));
  const zoom = MAP_ZOOM_BASE - pasos;
  return Math.min(MAP_ZOOM_MAX, Math.max(MAP_ZOOM_MIN, zoom));
}
